// Impressum.js – Seite /impressum (Rechtstext). Stil .ff-legal.
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./custom.css";
import usePageMeta from "../../usePageMeta";
import betrieb, { telefonLink, mailLink } from "../../data/betrieb";

function Impressum() {
  usePageMeta({
    path: "/impressum",
    title: `Impressum | ${betrieb.name}`,
    description: `Impressum von ${betrieb.name} – ${betrieb.rechtsname}, ${betrieb.strasse}, ${betrieb.plz} ${betrieb.ort}.`,
  });

  return (
    <div>
      <div className="ff-page-hero ff-page-hero--compact">
        <div className="ff-page-hero__content">
          <h1 className="ff-page-hero__title">Impressum</h1>
        </div>
      </div>
      <div className="custom-dark-green text-white">
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={9} className="ff-legal">

        {/* Marke, Rechtsname, Inhaber, Anschrift in dieser Reihenfolge (src/data/betrieb.js): Pflichtangaben für ein
            Einzelunternehmen und zugleich der Block, den Google mit dem Unternehmensprofil abgleicht */}
        <h2 className="ff-article-h3">Angaben gemäß § 5 DDG</h2>
        <p>
          {betrieb.name}
          <br />
          {betrieb.rechtsname}
          <br />
          Inhaber: {betrieb.inhaber}
          <br />
          {betrieb.strasse}
          <br />
          {betrieb.plz} {betrieb.ort}
        </p>

        <h2 className="ff-article-h3">Kontakt:</h2>
        <p>
          Telefon: <a href={telefonLink}>{betrieb.telefon}</a>
          <br />
          E-Mail: <a href={mailLink}>{betrieb.email}</a>
        </p>

        <h2 className="ff-article-h3">Verantwortlich für den Inhalt</h2>
        <p>
          Verantwortlich nach § 18 Abs. 2 MStV: {betrieb.inhaber}, Anschrift wie oben.
        </p>

        {/* Angabe des Inhabers (31.10.2026). Das ist die Steuernummer des Finanzamts, keine Umsatzsteuer-Identifikationsnummer
            (Format DE123456789). Erhält der Betrieb eine USt-IdNr., diese hier zusätzlich als „Umsatzsteuer-ID gemäß § 27 a UStG“ angeben. */}
        <h2 className="ff-article-h3">Steuernummer:</h2>
        <p>26/187/069007</p>

        <h2 className="ff-article-h3">Haftungsausschluss (Disclaimer)</h2>
        <p>
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für
          die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen
          wir jedoch keine Haftung.
        </p>

        <h2 className="ff-article-h3">Verbraucherschlichtung:</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2 className="ff-article-h3">Urheberrecht:</h2>
        <p>
          Alle auf dieser Website verwendeten Inhalte, insbesondere Texte,
          Bilder, Grafiken und Logos, sind urheberrechtlich geschützt und dürfen
          ohne ausdrückliche Zustimmung des Rechteinhabers nicht verwendet
          werden.
        </p>

        <p>
          Dieses Impressum gilt auch für die Social-Media-Profile von {betrieb.name} ({betrieb.rechtsname}),
          insbesondere für das Instagram-Profil{" "}
          <a href={betrieb.instagram} target="_blank" rel="noopener noreferrer">
            forst_und_flur
          </a>
          .
        </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Impressum;
